// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r4TfcQ1YC9HSpHEyDooz{max-width:none;border-radius:10px;background:var(--color-515-baly);padding:70px 45px 45px}.ZRT6A03PLjX94dAZ9dfy{text-align:left;width:100%;max-width:800px}.ZRT6A03PLjX94dAZ9dfy .srp1fSi2WdXnVs0Sy8Cr{font-size:25px}.ZRT6A03PLjX94dAZ9dfy .k3l1sNFhU6NRh1qEtPWA{text-align:left;color:var(--color-515-blekitny);font-size:16px;line-height:150%}.ZRT6A03PLjX94dAZ9dfy .xRwAVbruJm3bMq1Wyd3L{line-height:150%;font-size:14px}.ZRT6A03PLjX94dAZ9dfy .SwUrjG9kvM9j8rM5T5wP{text-align:left;line-height:150%;font-weight:700;font-size:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `SwUrjG9kvM9j8rM5T5wP`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `r4TfcQ1YC9HSpHEyDooz`,
	"rootContent": `ZRT6A03PLjX94dAZ9dfy`,
	"title": `srp1fSi2WdXnVs0Sy8Cr`,
	"subtitle": `k3l1sNFhU6NRh1qEtPWA`,
	"list": `xRwAVbruJm3bMq1Wyd3L`
};
export default ___CSS_LOADER_EXPORT___;
